<template>
	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Pesquisa de Clientes" exibeVoltar="true" historyback="true"/>
        </div>
		<div class="app-centro-sem-rodape">
            <div>
                <input-pesquisa @pesquisar="pesquisar" :textoPesquisar="nomeClientePesquisar"/>
            </div>
            <div class="lista">


                <div v-if="pesquisaVazia" class="msg-error">
                    <center>
                        <i class="fas fa-exclamation-triangle"></i> Nenhum cliente encontrado!
                    </center>
                </div>

                <div @click="abriCliente(cliente)" class="item-lista" v-for="cliente in clientes" v-bind:key="cliente.COD_CLIENTE">
                    {{ cliente.NOME_CLIENTE }}
                </div>
            </div>      
        </div>
	</div>
</template>

<script>

import InputPesquisa from '@/components/shared/InputPesquisa.vue';
import TopBar from '@/components/layout/TopBar.vue';
import request from '@/services/services.js';


export default {
    name: 'PesquisaClientes',
    components: {
        InputPesquisa,
        TopBar
    },
    data() {
        return {
            nomeClientePesquisar : '',
            pesquisaVazia : false
        }        
    },

    computed : {
        clientes(){
            return this.$store.state.clientes
        }
    },


    beforeMount(){
        if(this.$ss.clientes)
        this.clientes = this.$ss.clientes;
        

        if(this.$ss.nomeClientePesquisar){
            this.nomeClientePesquisar = this.$ss.nomeClientePesquisar;
        }
        
    },

    methods: {
        pesquisar(nomeClientePesquisar){


            if (nomeClientePesquisar.length<3){
                alert('Ao menos 3 caracteres tem que ser digitados para pesquisa parcial !');
                return;
            }

            this.nomeClientePesquisar = nomeClientePesquisar;
            this.$ss.nomeClientePesquisar = this.nomeClientePesquisar;

            this.pesquisaVazia = false;

            request(this, 'GET',
                'Mobile_PesquisarClientes',
                `nome_cli=${nomeClientePesquisar}`)
            .then(res => {
                if(res){

                    this.$store.state.clientes = res.clientes;

                    if(this.clientes.length===0)
                    this.pesquisaVazia = true;                    

                }
            });

        },
        abriCliente(cliente){
            var objb64 = btoa(JSON.stringify(cliente.COD_CLIENTE));
            this.$router.push(`clientes/${objb64}`);
        }
    }

}
</script>

<style scoped>


</style>

